import { useEffect, useState } from "react";
import { RotateCcw, Save, SlidersHorizontal } from "lucide-react";
import { toast } from "sonner";
import { api, errorText } from "@/lib/api";
import "./TeamProjections.css";

const FIELDS = [["spread", "Spread", "pts", 0.5], ["total", "Game total", "pts", 0.5], ["moneyline", "Moneyline edge", "%", 1]];
const toForm = (m) => ({ spread: m.spread, total: m.total, moneyline: Math.round(m.moneyline * 1000) / 10 });

export function MarginsCard({ onSaved, compact = false }) {
  const [form, setForm] = useState(null);
  const [defaults, setDefaults] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.get("/team-value/margins").then((r) => { setForm(toForm(r.data.margins)); setDefaults(r.data.defaults); }).catch((e) => toast.error(errorText(e)));
  }, []);
  const save = async (values) => {
    setBusy(true);
    try {
      const r = await api.put("/team-value/margins", { spread: Number(values.spread), total: Number(values.total), moneyline: Number(values.moneyline) / 100 });
      setForm(toForm(r.data.margins));
      toast.success("Margins saved · games not started yet re-checked");
      onSaved?.();
    } catch (e) { toast.error(errorText(e)); } finally { setBusy(false); }
  };
  if (!form) return null;
  return (
    <div className={`tp-root ${compact ? "" : "mt-6"}`}>
      <div className="tp-card" data-testid="tv-margins-card">
        <h4><SlidersHorizontal size={13} className="inline mr-1" />TEAM VALUE MARGINS <small>(admin · how far the model must beat the DraftKings line)</small></h4>
        <div className="tv-vform tv-margins">{FIELDS.map(([k, label, unit, step]) => (
          <label key={k}><small>{label} ({unit})</small>
            <input type="number" step={step} min={step} value={form[k]} onChange={(e) => setForm({ ...form, [k]: e.target.value })} data-testid={`tv-margin-${k}`} /></label>
        ))}</div>
        <div className="tv-vactions">
          <button type="button" className="tv-vbtn primary" onClick={() => save(form)} disabled={busy} data-testid="tv-margins-save"><Save size={14} />{busy ? "Saving…" : "Save margins"}</button>
          <button type="button" className="tv-vbtn" onClick={() => save(toForm(defaults))} disabled={busy} data-testid="tv-margins-default"><RotateCcw size={14} />Defaults (3 · 6 · 8%)</button>
        </div>
        <p className="tp-note">New margins apply to games that have not started. Locked and graded picks keep the margins they were flagged with.</p>
      </div>
    </div>
  );
}
